import { call } from 'redux-saga/effects'
import { apolloClient } from '@fe/business/src/apollo'
import { INVALIDATE_KIOSK_WIDGETS_MUTATION } from './mutations/kioskWidgets'
import * as snack from './snackMessage'

const ERROR_MESSAGES = {
  INVALIDATION_FAILED: 'Failed to invalidate kiosk widgets',
  UNKNOWN_ERROR: 'Unknown error',
  UNKNOWN_WIDGET_LABEL: 'widget'
}

export function * invalidateKioskWidgetsFlow ({ clubId, widgetNames }) {
  const invalidationResult = yield call(invalidateKioskWidgetsEffect, { clubId, widgetNames })
  const errorMessage = getInvalidateKioskWidgetsErrorMessage(invalidationResult)

  if (errorMessage) {
    yield snack.setMessage(errorMessage)
  }

  return invalidationResult
}

function * invalidateKioskWidgetsEffect ({ clubId, widgetNames }) {
  if (!clubId) return null
  if (!Array.isArray(widgetNames) || widgetNames.length === 0) return null

  try {
    const mutationResult = yield call([apolloClient, apolloClient.mutate], {
      mutation: INVALIDATE_KIOSK_WIDGETS_MUTATION,
      variables: {
        input: {
          clubId,
          widgetNames
        }
      }
    })

    return mutationResult?.data?.kioskInvalidateWidgets
  } catch (error) {
    console.warn(ERROR_MESSAGES.INVALIDATION_FAILED, error)
    return { error }
  }
}

function getInvalidateKioskWidgetsErrorMessage (invalidationResult) {
  if (!invalidationResult) return null

  if (invalidationResult.error) {
    return ERROR_MESSAGES.INVALIDATION_FAILED
  }

  const hasErrors = invalidationResult.errors?.length > 0
  if (!invalidationResult.success || hasErrors) {
    return formatFirstError(invalidationResult.errors ?? [])
  }

  return null
}

function formatFirstError (errors) {
  const firstError = errors?.[0] ?? {}
  const widgetName = firstError.widgetName ?? ERROR_MESSAGES.UNKNOWN_WIDGET_LABEL
  const errorText = firstError.error ?? ERROR_MESSAGES.UNKNOWN_ERROR
  const extraCount = Math.max(0, errors.length - 1)
  const suffix = extraCount > 0 ? ` (+${extraCount} more)` : ''

  return `${ERROR_MESSAGES.INVALIDATION_FAILED} (${widgetName}: ${errorText})${suffix}`
}
